import React from 'react';
import Alert from '@material-ui/lab/Alert';
import { BitriseDownloadArtifactComponent } from '../BitriseDownloadArtifactComponent/BitriseDownloadArtifactComponent.esm.js';
import { useBitriseArtifacts } from '../useBitriseArtifacts.esm.js';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import { Progress } from '@backstage/core-components';

const BitriseArtifactsComponent = (props) => {
  const { value, loading, error } = useBitriseArtifacts(
    props.build.appSlug,
    props.build.buildSlug
  );
  if (loading) {
    return /* @__PURE__ */ React.createElement(Progress, null);
  } else if (error) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "error" }, error.message);
  } else if (!value || !value.length) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "info" }, "No artifacts");
  }
  return /* @__PURE__ */ React.createElement(List, null, value.map((row) => /* @__PURE__ */ React.createElement(ListItem, { key: row.slug }, /* @__PURE__ */ React.createElement(ListItemText, { primary: row.title, secondary: row.artifact_type }), /* @__PURE__ */ React.createElement(ListItemSecondaryAction, null, /* @__PURE__ */ React.createElement(
    BitriseDownloadArtifactComponent,
    {
      appSlug: props.build.appSlug,
      buildSlug: props.build.buildSlug,
      artifactSlug: row.slug
    }
  )))));
};

export { BitriseArtifactsComponent };
//# sourceMappingURL=BitriseArtifactsComponent.esm.js.map
